<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-01 11:28:51
 * @Description: 合作伙伴
 -->

<template>
  <div class="partner-wrapper">
    <a href="https://www.aliyun.com/">
      <img src="https://files.jinr.com/jinr-index/img/partner-01.jpg" alt="" srcset="" />
    </a>
    <a href="https://www.cunnar.com/">
      <img src="https://files.jinr.com/jinr-index/img/partner-02.jpg" alt="" srcset="" />
    </a>
    <a href="https://www.yeepay.com/">
      <img src="https://files.jinr.com/jinr-index/img/partner-03.jpg" alt="" srcset="" />
    </a>
    <a href="https://www.fadada.com">
      <img src="https://files.jinr.com/jinr-index/img/partner-04.png" alt="" srcset="" />
    </a>
    <a href="http://www.geotmt.com/">
      <img src="https://files.jinr.com/jinr-index/img/partner-05.png" alt="" srcset="" />
    </a>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scope>
.partner-wrapper {
  display: flex;
  padding: 40px;
  flex-wrap: wrap;
  justify-content: flex-start;
  a {
    width: 210px;
    height: 130px;
    margin: 20px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
